export default __webpack_public_path__ + "9c235ee792bb257c6336f0bbf2025ee4.png";